import { render } from "./Step2View.vue?vue&type=template&id=38ff8e99"
import script from "./Step2View.vue?vue&type=script&lang=js"
export * from "./Step2View.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__